import PropTypes from 'prop-types';

const UploadSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 50}`}
      height={`${height || 50}`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M42.708 21.2291H36.6872C31.7497 21.2291 27.7288 17.2083 27.7288 12.2708V6.24996C27.7288 5.10413 26.7913 4.16663 25.6455 4.16663H16.8122C10.3955 4.16663 5.20801 8.33329 5.20801 15.7708V34.2291C5.20801 41.6666 10.3955 45.8333 16.8122 45.8333H33.1872C39.6038 45.8333 44.7913 41.6666 44.7913 34.2291V23.3125C44.7913 22.1666 43.8538 21.2291 42.708 21.2291Z"
        fill={color}
      />
      <path
        d="M32.9163 4.60419C32.0622 3.75003 30.583 4.33336 30.583 5.52086V12.7917C30.583 15.8334 33.1663 18.3542 36.3122 18.3542C38.2913 18.375 41.0413 18.375 43.3955 18.375C44.583 18.375 45.208 16.9792 44.3747 16.1459C41.3747 13.125 35.9997 7.68753 32.9163 4.60419Z"
        fill={color}
      />
      <path
        d="M24.0212 25.9791L19.8545 21.8125C19.8337 21.7916 19.8128 21.7916 19.8128 21.7708C19.6878 21.6458 19.5212 21.5416 19.3545 21.4583C19.3337 21.4583 19.3337 21.4583 19.3128 21.4583C19.1462 21.3958 18.9795 21.375 18.8128 21.3541C18.7503 21.3541 18.7087 21.3541 18.6462 21.3541C18.5212 21.3541 18.3753 21.3958 18.2503 21.4375C18.1878 21.4583 18.1462 21.4791 18.1045 21.5C17.9378 21.5833 17.7712 21.6666 17.6462 21.8125L13.4795 25.9791C12.8753 26.5833 12.8753 27.5833 13.4795 28.1875C14.0837 28.7916 15.0837 28.7916 15.6878 28.1875L17.1878 26.6875V35.4166C17.1878 36.2708 17.8962 36.9791 18.7503 36.9791C19.6045 36.9791 20.3128 36.2708 20.3128 35.4166V26.6875L21.8128 28.1875C22.1253 28.5 22.5212 28.6458 22.917 28.6458C23.3128 28.6458 23.7087 28.5 24.0212 28.1875C24.6253 27.5833 24.6253 26.5833 24.0212 25.9791Z"
        fill={color}
      />
    </svg>
  );
};

UploadSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default UploadSvg;
